import MuiCard from '@mui/material/Card';
import { styled } from '@mui/material/styles';

export const Card = styled(MuiCard)`
  max-width: 480px;
  width: 480px;
`;
